import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  deleteANewsCat,
  getCategories,
  resetState,
} from "../features/CountryDataSclice";
import CustomModal from "../../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Country Category Data List", 
    dataIndex: "category_name"
  },
  {
    title: "Country Category",
    dataIndex: "Country_namee"
  },
  {
    title: "Country Name",
    dataIndex: "Country_name"
  },

  {
    title: "Action",
    dataIndex: "action",
  },
];

const Newscatlist = () => {
  const [open, setOpen] = useState(false);
  const [NewsCatId, setNewsCatId] = useState("");
  const [NewsCatIdd, setNewsCatIdd] = useState("");
  const [NewsCatIddd, setNewsCatIddd] = useState("");
  const showModal = (e1,e2,e3) => {
    setOpen(true);
    setNewsCatId(e1);
    setNewsCatIdd(e2);
    setNewsCatIddd(e3);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getCategories());
  }, []);
  const bCatState = useSelector((state) => state.countryData.pCategorySlice);
  console.log(bCatState);
  const data1 = [];
  for (let i = 0; i < bCatState.length; i++) {
    data1.push({
      key: i + 1,
      category_name: bCatState[i].data.courseName,
      Country_namee: bCatState[i].categoryName,
      Country_name: bCatState[i].countryName,
      action: (
        <>
          <Link
            to={`/admin/Add-Country-Data/${bCatState[i].countryId}/${bCatState[i].cityId}/${bCatState[i].data.id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(bCatState[i].countryId, bCatState[i].cityId, bCatState[i].subcollectionId)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNewsCategory = (e1,e2,e3) => {
    dispatch(deleteANewsCat({  id: e1, secondId: e2 , subcollectionId:e3}));
    setOpen(false);
    setTimeout(() => {
      dispatch(getCategories());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Country Categories Data List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNewsCategory(NewsCatId,NewsCatIdd,NewsCatIddd);
        }}
        title="Are you sure you want to delete this  Country?"
      />
    </div>
  );
};

export default Newscatlist;
